import { render, staticRenderFns } from "./SiteRouteList.vue?vue&type=template&id=0f1cc72f"
import script from "./SiteRouteList.vue?vue&type=script&lang=js"
export * from "./SiteRouteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports